export const CONTACT = {
  whatsapp: "https://wa.me/40775205609?text=Bun%C4%83%20ziua!%20A%C8%99%20dori%20detalii%20despre%20produsele%20EasyREW.",
  email: "easyREW@gmail.com",
  emailHref: "mailto:u5274325625@id.gle",
  phone: "+40 775 205 609",
  phoneHref: "tel:+40775205609",
  city: "București, România",
};

export const NAV = [
  { id: "cum-functioneaza", label: "Cum funcționează" },
  { id: "produse", label: "Produse" },
  { id: "beneficii", label: "Beneficii" },
  { id: "intrebari", label: "Întrebări" },
];

export const MARQUEE = [
  "O atingere, o recenzie",
  "Fără aplicații",
  "Fără abonament",
  "Cod QR de rezervă",
  "Acrilic premium",
  "Gata de folosit din cutie",
];

export const STEPS = [
  { n: "01", title: "Așezi standul la vedere", text: "Pe tejghea, pe masă sau lângă casă. Designul discret atrage privirea fără să deranjeze." },
  { n: "02", title: "Clientul apropie telefonul", text: "Cipul NFC e recunoscut instant de iPhone și Android. Pentru telefoanele mai vechi există codul QR." },
  { n: "03", title: "Recenzia se deschide singură", text: "Pagina ta de recenzii Google apare direct pe ecran. Clientul alege stelele și scrie câteva cuvinte." },
];

export const PRODUCTS = [
  { id: "stand", tag: "Cel mai ales", name: "Standul Acrilic", price: "200 lei", img: "/img/stand.jpg", desc: "Standul în formă de L, cu insigna de cinci stele, cip NFC și cod QR.", points: ["Acrilic bleu, finisaj lucios", "Cip NFC + cod QR", "Pentru tejghea sau masă"] },
  { id: "card", tag: "Portabil", name: "Cardul NFC", price: "100 lei", img: "/img/card.jpg", desc: "Cât un card bancar. Ideal pentru ospătari, frizeri sau servicii la domiciliu.", points: ["Format de buzunar", "Cip NFC + cod QR", "Ușor de dat din mână în mână"] },
  { id: "sticker", tag: "Discret", name: "Stickerul NFC", price: "125 lei", img: "/img/sticker.jpg", desc: "Se lipește pe ușă, vitrină, meniu sau oglindă. Mic, dar vizibil.", points: ["Se lipește pe orice suprafață netedă", "Cip NFC integrat", "Pentru vitrine și meniuri"] },
];

export const FAQ = [
  { q: "Cum ajunge link-ul meu de Google pe stand?", a: "După ce ne scrii, ne trimiți numele afacerii sau link-ul profilului Google. Programăm noi cipul NFC și codul QR, iar produsul ajunge la tine gata de folosit." },
  { q: "Funcționează pe toate telefoanele?", a: "Majoritatea telefoanelor moderne, iPhone și Android, citesc NFC fără nicio aplicație. Pentru celelalte, codul QR de pe produs face același lucru." },
  { q: "Există abonament sau taxe lunare?", a: "Nu. Plătești o singură dată produsul fizic și îl folosești cât timp vrei." },
  { q: "Cum comand?", a: "Scrie-ne pe WhatsApp, e-mail sau sună-ne. Îți confirmăm detaliile, prețul și livrarea în cel mai scurt timp." },
];
